import { PouchDBCookerDatabase } from './backend/pouchdb';
import { FetchCookerDatabase } from './backend/fetch';

let _database = null;
let _showOptions = true;
export function loadFallbackDB() {
    if (_database == null) {
        console.log('Loaded fallback DB');
        _database = new PouchDBCookerDatabase();
    } else {
        throw new Error('DB already initialized');
    }
}

export function loadFetchDB() {
    if (_database == null) {
        console.log('Loaded fetch backed DB');
        _database = new FetchCookerDatabase();
    } else {
        throw new Error('DB already initialized');
    }
}
/**
 * @return {CookerDatabase}
 */
export function getDatabase() {
    if (_database == null) {
        throw new Error('Grabbed database before it was loaded.');
    }
    return _database;
}

export function showOptions(opt = null){
    if(opt !== null){
        _showOptions = !!opt;
    }
    return _showOptions;
}

export function isWebApp() {
    return navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
}


// WEBPACK FOOTER //
// ./src/api/index.js